export enum RequestType {
    REGULAR = 0,
    MARKET  = 1,
    RETRACT = 2,
}
